import React, { useContext } from 'react'

import { DataContext } from './DataContext'
import NoDataComponent from '../../../elem/table/client/NoDataComponent'
import TableContent from '../../../elem/table/client/TableContent'

const columns = [
    {
        Header: 'Current Well Type',
        accessor: 'Current Well Type',
    },
    {
        Header: 'Previous Well Type',
        accessor: 'Previous Well Type',
    },
    {
        Header: 'Update Date',
        accessor: 'Update Date',
    },
]

export default () => {
    const { detailData, visibleTab, isLoading } = useContext(DataContext)
    if (detailData && detailData.wellTypeHistory && visibleTab === 'wellTypeHistory') {
        const wellTypeHistoryData = detailData.wellTypeHistory
        return (
            <div className="is-size-7 sampleDetailWrapper">
                <NoDataComponent
                    data={wellTypeHistoryData}
                    isLoading={isLoading}
                />
                {wellTypeHistoryData.length > 0 && (
                    <TableContent
                        name="wellTypeHistory"
                        columns={columns}
                        data={wellTypeHistoryData}
                        containerClass={'detailTableWrapper'}
                        loading={isLoading}
                        isClickable={false}
                    />
                )}
            </div>
        )
    } else {
        return null
    }
}
